import { BOOK } from "../content";
import { useCart } from "../context/CartContext";
import { Reveal } from "./Reveal";

const FinalCta = () => {
  const { addToCart } = useCart();
  return (
    <section className="relative py-24 lg:py-36 overflow-hidden" data-testid="final-cta-section">
      <div className="absolute inset-0 pointer-events-none" aria-hidden="true">
        <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-[50rem] h-[50rem] rounded-full border border-[#D4AF37]/10 animate-spin-slower" style={{ borderStyle: "dashed" }} />
        <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-[34rem] h-[34rem] rounded-full border border-[#D4AF37]/15" />
        <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-[22rem] h-[22rem] rounded-full bg-[#D4AF37]/8 blur-3xl" />
      </div>
      <div className="relative max-w-3xl mx-auto px-4 sm:px-6 text-center">
        <Reveal>
          <p className="font-serif-alt italic text-xl text-amber-200/80">Nothing new can grow in a life that never pauses.</p>
          <h2 className="mt-6 font-display text-4xl sm:text-5xl font-bold text-[#F8FAFC] leading-tight">
            The Archive is open.<br />For now, it costs ${BOOK.price.toFixed(2)}.
          </h2>
          <p className="mt-4 text-[#94A3B8]">
            <span className="line-through">${BOOK.originalPrice.toFixed(2)}</span> — the early-reader window closes soon.
          </p>
          <button
            data-testid="final-add-to-cart-button"
            onClick={addToCart}
            className="mt-10 rounded-full bg-[#D4AF37] px-10 py-5 text-lg font-semibold text-[#052730] transition-all duration-300 hover:bg-[#FCD34D] hover:shadow-[0_0_50px_rgba(212,175,55,0.5)] focus:outline-none focus:ring-2 focus:ring-[#FCD34D] active:scale-[0.97]"
          >
            Get the Reader's Edition — ${BOOK.price.toFixed(2)}
          </button>
          <p className="mt-4 text-xs text-[#94A3B8]">Instant PDF download · Personal email link · Secure checkout</p>
        </Reveal>
      </div>
    </section>
  );
};

export default FinalCta;
